import React, { useContext } from 'react';
import { DataContext } from 'entries/common/widgets/saved-project-configuration/context';
import { FormRouter } from './form-router';
import { Container } from './styles';

export const Content = () => {
  const { data } = useContext(DataContext);
  const hasPresaleProps = Boolean(data?.presaleProps);

  return (
    <Container noXPadding={hasPresaleProps}>
      <FormRouter />
    </Container>
  );
};
